<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable
          placeholder="Chọn công ty"
          :limit="company_obj.limit"
          :loading="company_obj.loading"
          :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN"
          v-model="company"
          :options="company_obj.items"
          :total="company_obj.total"
          @keyup="emitEvent"
          @offset="changeOffset"
        />
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
        ></BaseDatatable>
        <Dialog header="Xóa" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Bạn có chắc muốn xóa khu vực này không?
          <template #footer>
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button label="Hủy" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning callback-btn" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from "@/core/DataServices";
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from "./list";
import DropdownScrollable from "@/components/DropdownScrollable.vue";

export default {
  components: {
    BaseDatatable,
    DropdownScrollable,
  },
  data() {
    return {
      filters: {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: "",
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction: null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: "edit",
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete: {},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false,
      },
      company_id: null,
    };
  },
  async created() {
    await this.initParams();
    if (this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
      await this.getListCompany();
    }
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    this.$store.commit("setLoading", true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query) && !this.$commonFuction.isEmpty(this.$route.query.company_id)) {
      if (this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = { id: this.$route.query.company_id };
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.company_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
  },
  watch: {
    $route: "initParams",
    async company() {
      if (this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company_id = this.company.id;
        this.componentKey++;
      }
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, "name");
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if (token) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", { filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset }, { headers })
          .then((res) => {
            if (this.company_obj.offset > 0) {
              this.company_obj.items.push(...res.data.data.company);
            } else {
              this.company_obj.items = res.data.data.company;
            }
            this.company_obj.total = res.data.data.total;
            this.company_obj.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
          });
      }
    },
    async initParams() {
      this.$store.commit("setLoading", true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = { id: this.$store.getters?.company_id };
        this.company_id = this.$store.getters?.company_id;
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, "title", this.dataModel.label);
    },
    onChange() {
      this.$store.commit("setLoading", true);
      this.$apollo.queries.listData.refresh();
    },
    DataOnChange(data, f) {
      if (f.type == "Checkbox") {
        console.log("change")
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name);
      var result = [];
      if (field.type == "Selection") {
        if (field.options) result = field.options;
        else if (field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : [];
      }
      return result;
    },
    getRowActions() {
      var actions = {};
      var that = this;
      if (that.$store.getters.controllers?.list_zone && that.$store.getters.controllers?.list_zone.includes("add")) {
        actions.header = { name: "add", icon: "plus", path: "list-zone/add" };
      }
      actions.rows = function (rowData) {
        var buttons = {};
        if (that.$store.getters.controllers?.list_zone && that.$store.getters.controllers?.list_zone.includes("edit")) {
          buttons.edit = { name: "edit", icon: "pencil", key: "id", path: "list-zone/edit/" };
        }
        if (that.$store.getters.controllers?.list_zone && that.$store.getters.controllers?.list_zone.includes("delete")) {
          buttons.delete = { name: "delete", icon: "trash", key: "id" };
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData);
          Object.assign(buttons, modelaction);
        }
        return buttons;
      };
      return actions;
    },
    async onActionClicked(payload) {
      var action = payload.action;
      var data = null;
      if (payload.data) {
        data = payload.data;
      }
      var pageTransaction = new Date().getTime();
      switch (action.name) {
        case "view":
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] });
          } else {
            this.editId = data.data[action.key];
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case "edit":
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id } });
          } else {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key];
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case "delete":
          this.deleteId = data.data[action.key];
          this.deleteName = data.data.name;
          this.dataDelete = data.data;
          this.showDeleteDialog = true;
          break;
        case "add":
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path, query: { company_id: this.company_id } });
          } else {
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case "custom":
          await action.handler(data.data, this);
          this.componentKey++;
          break;
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if (token) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        var that = this;
        await ApiRepository.post("/_api/zone/delete", { id: that.deleteId, company_id: that.company.id }, { headers })
          .then(function () {
            that.componentKey += 1;
          })
          .catch(() => {
            that.$toast.add({ severity: "error", summary: "Lỗi", detail: "Xóa dữ liệu thất bại", life: 3000 });
          });
      }
    },
  },
};
</script>

<style lang="css">
.p-calendar .p-datepicker {
  width: 280px;
  padding: 0px;
  padding-top: 5px;
}
.p-calendar .p-datepicker td,
.p-calendar .p-datepicker td a {
  padding: 0px !important;
}
.p-calendar .p-datepicker td span {
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;
}
.p-datepicker .p-datepicker-header {
  padding: 5px !important;
}
.p-button-warning-o .p-button-label-o {
  color: #e95d57;
}
.p-button-warning .pi-times {
  color: #e95d57;
}
</style>
